/* eslint-disable no-restricted-syntax -- The values below are Google Maps JSON
   basemap colours (dark greys + deep-blue water for the night map), i.e. raw
   third-party map-render data, NOT BraveMove brand tokens. The design-token system
   intentionally does not model a third-party map palette, so these hex literals
   are the source of truth and are exempt from the no-raw-hex guard. */

/**
 * Dark ("midnight") Google Maps style array for `<MapView dark>`.
 *
 * Hand-tuned dark greys with deep-navy water and muted labels so the
 * accent-coloured sport pins read clearly against the basemap. POI-business,
 * transit, and map icons are hidden for a clean operational view. Passed
 * verbatim to `google.maps.Map.setOptions({ styles })`.
 */
export const DARK_MAP_STYLE = [
  { elementType: 'geometry', stylers: [{ color: '#1b2230' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#1b2230' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#8b94a7' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#3b4456' }] },
  {
    featureType: 'administrative.country',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9aa4ba' }],
  },
  { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#c2cad8' }],
  },
  { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#6f7889' }] },
  { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#24323b' }] },
  { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#5a7d63' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#2a3140' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#1b2230' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#9aa4ba' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#3b4456' }] },
  { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#1b2230' }] },
  { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#b8c0d0' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0e1626' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#46566f' }] },
];
